import { setInstanceGetter } from '@wix/wix-vod-shared/dist/src/common/utils/get-auth-header';
export var setInstance = function (instance) { return setInstanceGetter(function () { return instance; }); };
